import { ArrowUpRight } from "lucide-react";
import Reveal, { SectionLabel } from "./Reveal";
import { WHATSAPP_URL } from "@/lib/scroll";

const ITEMS = [
  "Dor de cabeça frequente",
  "Cansaço que o descanso não resolve",
  "Dificuldade de concentração",
  "Esquecimentos que antes não existiam",
  "Formigamento, fraqueza ou tontura que vêm e passam",
  "Passou por um AVC e sente que falta acompanhamento no dia a dia",
  "Já passou por consultas e saiu sem uma explicação clara",
];

export default function Sintomas() {
  return (
    <section id="sintomas" className="bg-cream py-28 md:py-36">
      <div className="mx-auto max-w-[1240px] px-5 md:px-10">
        <SectionLabel n="01">Sintomas</SectionLabel>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-4xl font-display font-medium text-[clamp(2.1rem,4.6vw,4rem)] leading-[1.06] tracking-[-0.01em]">
            Isso acontece ou <em className="font-serifd italic text-terra">já aconteceu</em> com
            você?
          </h2>
        </Reveal>

        <ul className="mt-14 md:mt-20 border-t border-olive/15" data-testid="sintomas-list">
          {ITEMS.map((item, i) => (
            <Reveal key={item} delay={0.05 * i} y={20}>
              <li className="group flex items-baseline gap-5 md:gap-10 border-b border-olive/15 py-6 md:py-7 transition-all duration-500 hover:pl-3">
                <span className="font-display italic text-sm md:text-base text-terra/60 w-8 shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-display font-medium text-[clamp(1.35rem,3vw,2.35rem)] leading-snug text-olive transition-colors duration-300 group-hover:text-terra">
                  {item}
                </span>
                <ArrowUpRight className="ml-auto hidden sm:block size-6 shrink-0 text-terra opacity-0 -translate-x-2 translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0" />
              </li>
            </Reveal>
          ))}
        </ul>

        <Reveal delay={0.1}>
          <p className="mt-12 whitespace-nowrap text-[clamp(0.5rem,2vw,1.25rem)] text-olive/75">
            Se alguma dessas situações é a sua, a conversa começa por aqui.{" "}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sintomas-cta-whatsapp"
              className="font-semibold text-terra underline decoration-terra/40 underline-offset-4 transition hover:decoration-terra"
            >
              Fale comigo no WhatsApp
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
